export default __webpack_public_path__ + "static/image3-0e97d3a832d1a80804dc314ef572971f.gif";